import * as actionTypes from '../actions/actionTypes';

const initialState = {
	loading: false,
	error: null,
	id: '',
	name: '',
	siteDataLoaded: false,
	labors: [],
	units: [],
	events: []
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_SELECTED_START:
			return {
				...state,
				error: null,
				loading: true
			};
		case actionTypes.SET_SELECTED_SUCCESS:
			return {
				loading: false,
				error: null,
				siteDataLoaded: false,
				id: action.site.id || '',
				name: action.site.name || '',
				labors: [],
				units: [],
				events: []
			};
		case actionTypes.SET_SELECTED_FAIL:
			return {
				...state,
				error: action.error,
				loading: false
			};
		case actionTypes.GET_SITE_DATA_START:
			return {
				...state,
				error: null,
				loading: true
			};
		case actionTypes.GET_SITE_DATA_SUCCESS:
			return {
				...state,
				error: null,
				loading: false,
				siteDataLoaded: true,
				labors: action.data.labors,
				units: action.data.units,
				events: action.data.events
			};
		case actionTypes.GET_SITE_DATA_FAIL:
			return {
				...state,
				error: action.error,
				loading: false
			};
		case actionTypes.GET_OOS_UNITS_START:
			return {
				...state,
				error: null,
				loading: true
			};
		case actionTypes.GET_OOS_UNITS_SUCCESS:
			return {
				...state,
				error: null,
				loading: false,
				units: action.units
			};
		case actionTypes.GET_OOS_UNITS_FAIL:
			return {
				...state,
				error: action.error,
				loading: false
			};
		default:
			return state;
	}
}

export default reducer;